import Controller from '@ember/controller';
import { action } from '@ember/object';
import type { ApplicationModel } from 'login/routes/application';
import { encodeBase64, fetchAssertionOptions } from 'logon-utils/logon-utils';

export default class ApplicationIndexController extends Controller<ApplicationModel> {
  private async getCredentials(): Promise<void> {
    const publicKeyCredentialRequestOptions = await fetchAssertionOptions();

    const credentialRequestOptions: CredentialRequestOptions = {
      publicKey: publicKeyCredentialRequestOptions,
    };

    const credential = (await navigator.credentials.get(
      credentialRequestOptions,
    )) as PublicKeyCredential | null;

    if (credential === null) {
      throw new Error('No credential retrieved');
    }

    const assertionResponse = credential.response as AuthenticatorAssertionResponse;

    const credentialId = document.getElementById('credentialId') as HTMLInputElement;
    credentialId.value = encodeBase64(new Uint8Array(credential.rawId));

    const clientDataJSON = document.getElementById('clientDataJSON') as HTMLInputElement;
    clientDataJSON.value = encodeBase64(new Uint8Array(assertionResponse.clientDataJSON));

    const authenticatorData = document.getElementById('authenticatorData') as HTMLInputElement;
    authenticatorData.value = encodeBase64(new Uint8Array(assertionResponse.authenticatorData));

    const signature = document.getElementById('signature') as HTMLInputElement;
    signature.value = encodeBase64(new Uint8Array(assertionResponse.signature));

    const clientExtensionsJSON = document.getElementById(
      'clientExtensionsJSON',
    ) as HTMLInputElement;
    clientExtensionsJSON.value = JSON.stringify(credential.getClientExtensionResults());

    const loginForm = document.getElementById('loginForm') as HTMLFormElement;
    loginForm.submit();
  }

  @action async logonWithPasskey(): Promise<void> {
    try {
      return await this.getCredentials();
    } catch {
      // in case of an error, we do nothing
      void Promise.resolve();
    }
  }
}
